import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-666c13e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "q-pa-md" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-bottom":"15px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Cerere concediu - Actiune solicitata", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "absolute-right q-pa-md" }
const _hoisted_10 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_11 = { style: {"width":"65%","display":"flex","flex-direction":"row"} }
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column","width":"100%"} }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Id", -1))
const _hoisted_15 = { class: "col-8 form__label__black" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Angajat", -1))
const _hoisted_18 = { class: "col-8 form__label__black" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Tip cerere", -1))
const _hoisted_21 = { class: "col-8 form__label__black" }
const _hoisted_22 = {
  key: 0,
  class: "row"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Nr zile / Drept / Recalculat", -1))
const _hoisted_24 = { class: "col-8 form__label__black" }
const _hoisted_25 = {
  key: 1,
  class: "row"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Nr zile / Drept", -1))
const _hoisted_27 = { class: "col-8 form__label__black" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Prima zi", -1))
const _hoisted_30 = { class: "col-8 form__label__black" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Ultima zi", -1))
const _hoisted_33 = { class: "col-8 form__label__black" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Stare", -1))
const _hoisted_36 = { class: "col-8 form__label__black" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Observatie", -1))
const _hoisted_39 = { class: "col-8 form__label__black" }
const _hoisted_40 = {
  key: 2,
  class: "row"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Data rechemare", -1))
const _hoisted_42 = { class: "col-8 form__label__black" }
const _hoisted_43 = { style: {"min-width":"15vw"} }
const _hoisted_44 = {
  key: 3,
  class: "row"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Utilizator rechemat", -1))
const _hoisted_46 = { class: "col-8 form__label__black" }
const _hoisted_47 = {
  key: 4,
  class: "row"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Motiv", -1))
const _hoisted_49 = { class: "col-8 form__label__black" }
const _hoisted_50 = { style: {"width":"35%","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"} }
const _hoisted_51 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_52 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente atasate", -1))
const _hoisted_54 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_57 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_61 = { class: "mobile-only" }
const _hoisted_62 = {
  key: 0,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}
const _hoisted_63 = {
  key: 1,
  id: "iframe_preview_scan",
  type: "application/pdf",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none"}
}
const _hoisted_64 = {
  key: 2,
  id: "iframe_preview_scan",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none","display":"block"}
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_66 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_input = _resolveComponent("q-input")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_form, { ref: "myForm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                      }, _hoisted_8, 2),
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.timeRequest.appid != 0 && _ctx.timeRequest.stare != 'cancellation')
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              label: "Vizualizeaza cererea",
                              color: "brown-5",
                              icon: "file_copy",
                              onClick: _ctx.onPreviewCerereCO,
                              style: {"margin-right":"5px"},
                              size: "sm"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        ((_ctx.timeRequest.appid != 0 && _ctx.timeRequest.nr_recall_days != 0 && _ctx.timeRequest.nr_recall_days != null && _ctx.timeRequest.stare != 'cancellation'))
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 1,
                              label: "Vizualizeaza rechemarea",
                              color: "brown-5",
                              icon: "file_copy",
                              onClick: _ctx.onPreviewCerereRechemare,
                              style: {"margin-right":"5px"},
                              size: "sm"
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.timeRequest.appid), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _hoisted_17,
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.timeRequest.last_name) + " " + _toDisplayString(_ctx.timeRequest.first_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.timeRequest.tip_concediu), 1)
                          ]),
                          (_ctx.timeRequest.nr_days_recalculated != 0 && (Number(_ctx.timeRequest.flag) & 8) != 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.timeRequest.nr_working_days) + " / " + _toDisplayString(_ctx.timeRequest.nr_zile_drept) + " / " + _toDisplayString(_ctx.timeRequest.nr_days_recalculated), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.timeRequest.nr_working_days) + " / " + _toDisplayString(_ctx.timeRequest.nr_zile_drept), 1)
                              ])),
                          _createElementVNode("div", _hoisted_28, [
                            _hoisted_29,
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.timeRequest.start_date), 1)
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.timeRequest.end_date), 1)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.timeRequest.denumire_stare), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.timeRequest.observatie), 1)
                          ]),
                          (Number(_ctx.timeRequest.recall_date?.length) > 0 && _ctx.timeRequest.recall_date != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("span", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeRequest.recall_date, (recalldate, index) => {
                                      return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(_ctx.displayDataRO(recalldate) + (index != (_ctx.timeRequest.recall_date?.length - 1) ? ", " : "")), 1))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.timeRequest.nume_prenume_rechemat != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _hoisted_45,
                                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.timeRequest.nume_prenume_rechemat), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.timeRequest.description_recall != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _hoisted_48,
                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.timeRequest.description_recall), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", {
                            class: _normalizeClass({ column: _ctx.$q.platform.is.mobile, row: _ctx.$q.platform.is.desktop })
                          }, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", null, [
                                _hoisted_53,
                                _withDirectives(_createElementVNode("div", _hoisted_54, " Nimic atasat ", 512), [
                                  [_vShow, 
                                  _ctx.timeRequest.scansTimeRequests != null &&
                                  _ctx.timeRequest.scansTimeRequests.length == 0 &&
                                  !_ctx.uploadingFileToServer
                              ]
                                ])
                              ]),
                              (_ctx.user.auth_for_upload_scan == 'y')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      color: "primary",
                                      icon: "add_box",
                                      "no-caps": "",
                                      size: "lg",
                                      disable: _ctx.loadingData,
                                      onClick: _ctx.openFormUploadFile
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, {
                                          "transition-show": "rotate",
                                          "transition-hide": "rotate"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Incarca document nou ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["disable", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", null, [
                                (_ctx.uploadingFileToServer)
                                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                                      key: 0,
                                      color: "primary",
                                      size: "3em",
                                      thickness: 10
                                    }))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_57, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeRequest.scansTimeRequests, (scan) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: scan.appid
                                          }, [
                                            (_ctx.timeRequest.stare === 'initiat' || _ctx.user.is_admin === 'y')
                                              ? (_openBlock(), _createElementBlock("td", _hoisted_58, [
                                                  _createElementVNode("span", {
                                                    class: "material-icons cursor-pointer",
                                                    style: {"color":"red","font-size":"1.3rem"},
                                                    onClick: ($event: any) => (_ctx.askIfRemoveScan(scan))
                                                  }, "delete_forever", 8, _hoisted_59)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("td", null, _toDisplayString(scan.file_ext), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.file_size)), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_60, _toDisplayString(scan.description), 1),
                                              _createElementVNode("div", _hoisted_61, _toDisplayString(scan.description), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_btn, {
                                                round: "",
                                                color: "black",
                                                icon: "cloud_download",
                                                size: "xs"
                                              }),
                                              _createVNode(_component_q_menu, {
                                                fit: "",
                                                "transition-show": "scale",
                                                "transition-hide": "scale"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DialogOpenScan, {
                                                    appid: scan.appid,
                                                    type_scan: "TimeRequest"
                                                  }, null, 8, ["appid"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                              ])
                            ])
                          ], 2)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.timeRequest.stare !== 'initiat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createVNode(_component_TaskList, {
                          appid: _ctx.appid,
                          task: _ctx.task,
                          onState: _ctx.onState,
                          isSuccess: _ctx.isSuccess
                        }, null, 8, ["appid", "task", "onState", "isSuccess"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_q_dialog, {
            modelValue: _ctx.showPreviewFile,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showPreviewFile) = $event)),
            persistent: "",
            maximized: true,
            "transition-show": "slide-up",
            "transition-hide": "slide-down"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { class: "bg-white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_bar, null, {
                    default: _withCtx(() => [
                      _createElementVNode("h5", null, _toDisplayString(_ctx.titleForPreviewForm), 1),
                      _createVNode(_component_q_space),
                      _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        dense: "",
                        flat: "",
                        icon: "close"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, {
                            "transition-show": "rotate",
                            "transition-hide": "rotate"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Close")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      (_ctx.downloadingFile)
                        ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                            key: 0,
                            query: "",
                            "track-color": "orange",
                            color: "purple",
                            class: "q-mt-sm"
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isPDFFileType)
                        ? (_openBlock(), _createElementBlock("iframe", _hoisted_63))
                        : (_openBlock(), _createElementBlock("img", _hoisted_64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_q_dialog, {
            modelValue: _ctx.dialogUploadFile,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
            position: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card, { style: {"width":"350px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_linear_progress, {
                    value: 0.6,
                    color: "pink"
                  }),
                  _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
                    default: _withCtx(() => [
                      _hoisted_65,
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_q_input, {
                          counter: "",
                          outlined: "",
                          modelValue: _ctx.uploadScanTitle,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                          label: "Titlu document (minim 4 caractere)",
                          dense: "",
                          maxlength: "200"
                        }, null, 8, ["modelValue"])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "file",
                        name: "fileToUpload",
                        id: "fileToUpload",
                        ref: "myFileToUpload",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.prepareForUpload($event))),
                        style: {"margin-bottom":"10px"}
                      }, null, 544), [
                        [_vShow, _ctx.uploadScanTitle.length > 3]
                      ]),
                      _withDirectives(_createVNode(_component_q_btn, {
                        disable: !(_ctx.uploadScanTitle.length>3),
                        icon: "cloud_upload",
                        color: "white",
                        "text-color": "black",
                        label: "Salveaza pe server",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadFile())),
                        loading: _ctx.uploadingFileToServer,
                        style: {"margin-bottom":"5px"}
                      }, null, 8, ["disable", "loading"]), [
                        [_vShow, _ctx.checkIfFileIsSelected]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
  ]))
}